import { useEffect, useRef } from "react";
import { RANK_FIELD } from "./ranking";

// Radar only counts goals ranked on both lists, so a goal without a rank gets one, in the order the user
// is shown, as soon as the Goals page opens (both orders, whichever view is showing).
// For each of `views`, save(view, orderFor(view)) runs once per set of unranked goals: a goal added later
// is ranked too, and a failed write is tried again the next time the page opens. onFail(error, view) reports it.
export function useSeedRanks(views, goals, orderFor, save, onFail) {
  const tried = useRef(new Set());
  const pending = views.map(view => {
    const ids = (goals || []).filter(g => g.status === "active" && g[RANK_FIELD[view]] == null).map(g => g.id).sort();
    return { view, key: ids.length ? `${view}:${ids.join(",")}` : null };
  });
  const keys = pending.map(p => p.key).join("|");
  useEffect(() => {
    pending.forEach(({ view, key }) => {
      if (!key || tried.current.has(key)) return;
      tried.current.add(key);
      save(view, orderFor(view)).catch(e => { tried.current.delete(key); onFail(e, view); });
    });
    // Runs when the set of unranked goals changes; orderFor and save are new each render by design.
  }, [keys]); // eslint-disable-line react-hooks/exhaustive-deps
}
